import Vue from "vue";

import ProductSort from "./ProductSort.vue";

export function load() {
    const selector = "rewards-product-sort";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(ProductSort, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
